import Select from "react-select";
import endpoints from "../../config/endpoints";
import { Sidebar } from "../../layouts/Sidebar";
import { ReactElement, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setLoading } from "../../services/reducers/homeSlice";
import restApi from "../../services/restApi";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import alertHandler from "../../utils/alertHandler";
import tools from "../../utils/tools";

const SpecificManage = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState<any>({});
  const [selectedValues, setSelectedValues] = useState({});

  const list = () => {
    const rows: ReactElement[] = [];

    Object.entries(selectedValues).map(
      ([key, value]: [key: string, value: any], index) => {
        rows.push(
          <span key={index} className="specificValues">
            <span className="specificValue">
              <label>عنوان</label>
              <input
                className="addInput"
                value={value.title}
                onChange={(input) =>
                  setSelectedValues((prev) => {
                    const cp = { ...prev };

                    cp[key].title = input.target.value;

                    return cp;
                  })
                }
              />
            </span>
            <i className="trash width40p" onClick={() => deleteValue(key)}></i>
          </span>,
        );
      },
    );

    return rows;
  };

  const deleteValue = async (key) => {
    if (key.at(0) == "n") {
      setSelectedValues((prev) => {
        const cp = { ...prev };

        delete cp[key];

        return cp;
      });
      return;
    }
    dispatch(setLoading(true));

    const res = await restApi(endpoints.specific.value + key).delete({});

    alertHandler([res], "مقدار با موفقیت حذف شد", () =>
      setSelectedValues((prev) => {
        const cp = { ...prev };

        delete cp[key];

        return cp;
      }),
    );

    dispatch(setLoading(false));
  };

  const send = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.specific.basic + (id || ""), true).post(
      {
        title: form.title,
        description: form.description,
        values: selectedValues,
      },
    );

    if (res.code == 200) {
      Swal.fire({
        title: "موفق",
        text: `مشخصه فنی با موفقیت ${id ? "ویرایش" : "ثبت"} شد`,
        icon: "success",
        confirmButtonText: "متوجه شدم",
      });
    } else {
      Swal.fire({
        title: "ناموفق",
        text: res?.data,
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
    }

    dispatch(setLoading(false));
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    const res = await Promise.all([
      id && restApi(endpoints.specific.single + id).get(),
    ]);

    if (res[0]?.code == 200) {
      setForm(res[0].data);

      const vals = {};
      res[0].data?.specificValues?.map(
        (e) =>
          (vals[e.id] = {
            title: e.title,
            oldSpecificValueId: e.oldSpecificValueId,
          }),
      );

      setSelectedValues(vals);
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <main className="dashboardBody">
        <Sidebar />
        <div className="dashBoardMain main">
          <div className="addInfoHeader">
            <span
              className="dashboardHeader keepRight clickable"
              onClick={send}
            >
              ارسال
            </span>
            <span>
              <h1 className="sideBarTitle">بازگشت به صفحه مشخصات فنی</h1>
              <h1 className="dashBoardTitle">
                {id ? "ویرایش" : "ثبت"} مشخصات فنی{" "}
              </h1>
            </span>
            <i
              className="backAdd clickable"
              onClick={() => navigate("/specific/")}
            ></i>
          </div>
          <section className="bottomSection">
            <h1 className="dashBoardTitle">اطلاعات مشخصات فنی</h1>
            <label className="sideBarTitle" htmlFor="infoTitle">
              عنوان
            </label>
            <input
              className="addInput"
              id="infoTitle"
              onChange={(input: any) =>
                setForm((prev) => ({ ...prev, title: input.target.value }))
              }
              value={form?.title}
            />
            <label className="sideBarTitle" htmlFor="infoAmount">
              توضیحات
            </label>
            <textarea
              className="addInput"
              placeholder="توضیحات"
              id="infoAmount"
              onChange={(input: any) =>
                setForm((prev) => ({
                  ...prev,
                  description: input.target.value,
                }))
              }
              value={form?.description}
            />
            <label className="sideBarTitle">مقادیر</label>
            {list()}
            <button
              className="dashboardHeader"
              onClick={() =>
                setSelectedValues((prev) => ({
                  ...prev,
                  ["n" + Object.values(selectedValues).length]: {
                    title: "",
                    oldId: "",
                  },
                }))
              }
            >
              افزودن آپشن +
            </button>
          </section>
        </div>
      </main>
    </>
  );
};
export default SpecificManage;
